import Handlebars from "utilities/vendor/handlebars/4.7.6/js/handlebars";
import hbs from "utilities/vendor/handlebars/4.7.6/js/handlebars";
import focusTrapUtility from "utilities/global/focus-trap-utility/1.2.3/js/focus-trap-utility";
import spartaEventsUtility from "utilities/global/sparta-events-utility/2.3.3/js/sparta-events-utility";
import "utilities/global/sparta-global-data-utility/1.0.0/js/sparta-global-data-utility";
import spartaGlobalFunctions from "utilities/global/sparta-global-functions-utility/2.1.2/js/sparta-global-functions-utility";
import spartaMediaQueryUtility from "utilities/global/sparta-mediaquery-utility/3.0.5/js/sparta-mediaquery-utility";
import spartaSingletonUtility from "utilities/global/sparta-singleton-utility/1.0.0/js/sparta-singleton-utility";
import spartaStoreUtility from "utilities/global/sparta-store-utility/3.1.1/js/sparta-store-utility";
import spartaStyleUtility from "utilities/global/sparta-style-utility/4.4.0/js/sparta-style-utility";
import cardHelper from "utilities/helpers/helpers-card/1.2.0/js/helpers-card";
import spartaHelpers from "utilities/helpers/helpers-sparta/3.0.5/js/helpers-sparta";
import jQuery from "utilities/vendor/jquery/3.5.1/js/jquery";
import $ from "utilities/vendor/jquery/3.5.1/js/jquery";





const instance = {};






const SpartaUILayersModal = {









  buildHTML: (utility, options, $link, classDefaults, linkDefaults) => {
    const settings = new (function SettingsConstructor() {
      this.modalID = options.layerId;
      this.contentWrapperId = options.rel || 'modalContentInt';
      this.dismissible = (options.closeButton !== false);


      this.modalCloseText = `${options.closeText}`;
      this.modalAdaText = `${this.modalCloseText} ${options.closeAdaText}`.trim();

      this.continueLink = $link.attr('href');
      this.anchorID = $link.attr('id');
      this.titleTag = 'h1';
      this.classesToAdd = [
        options.interstitialType ? 'spa-ui-modal-interstitial' : 'spa-ui-modal-default',
        options.layerClass,
        options.modalLayer.class,
      ];


      if (options.optionalClasses) {
        this.classesToAdd = this.classesToAdd.concat(options.optionalClasses.split(' '));
      }


      this.classDefaults = classDefaults;
      this.linkDefaults = linkDefaults;


      this.interstitialContent = utility.layers[options.interstitialType];


      this.skin = options.interstitialType && options.interstitialType.length
        ? SpartaUILayersModal.setBranding(options.interstitialBranding)
        : SpartaUILayersModal.setBranding(options.branding);


      if (this.interstitialContent) {
        this.title = new Handlebars.SafeString(this.interstitialContent.header).string;
      } else if ($(options.$content).find(`#${options.contentId}_title`)) {
        this.title = $(options.$content).find(`#${options.contentId}_title`).html();
      } else {
        this.title = options.modalTitle || options.title || options.titleText;
      }


      if (this.interstitialContent) {
        this.content = new Handlebars.SafeString(this.interstitialContent.body).string;
      } else if (options.$content instanceof $) {
        this.content = options.$content.detach().removeClass('hide');
      } else {
        this.content = options.$content;
      }
    })();


    instance[settings.modalID] = settings;


    if (settings.interstitialContent) {
      settings.content = SpartaUILayersModal.modalCTA(options, settings);
    } else if (!settings.title) {



      SpartaUILayersModal.setTitleFromADA(settings, options);
    }


    const modalCardJCR = {
      dismissible: settings.dismissible,
      dismissibleADA: settings.interstitialContent
        ? new Handlebars.SafeString(
          `${options.closeText}: ${settings.interstitialContent.header}`,
        ).string
        : settings.modalAdaText,
      dismissibleClass: 'spa-ui-layer-close',
      title: settings.title || '',
      titleTag: settings.titleTag,
      skin: settings.skin,
      markup: {
        content: ' ', 
      },
      config: {
        titleID: `${options.contentId}_title`,
        bodyID: settings.interstitialContent
          ? `${options.contentId}`
          : '',
      },
    };


    return SpartaUILayersModal.formatHTML(utility, options, settings, modalCardJCR);
  },









  formatHTML: (utility, options, settings, modalCardJcr) => {

    const modalLayerElement = document.createElement('div');
    modalLayerElement.id = options.layerId;
    modalLayerElement.style.zIndex = utility._getNextZindex(options);
    settings.classesToAdd.forEach((name) => {
      modalLayerElement.classList.add(name);
    });


    modalLayerElement.innerHTML = cardHelper.render(modalCardJcr).string;


    if (settings.interstitialContent) {
      $(modalLayerElement).find('.spa-card__body').append(settings.content);
      $(modalLayerElement).find('.spa-card__body').wrapInner('<div class=\'content\'></div>');
    } else if (settings.content instanceof $) {

      settings.content.appendTo($(modalLayerElement).find('.spa-card__body'));
    } else {
      $(modalLayerElement).find('.spa-card__body').append(settings.content);
    }



    if (!modalLayerElement.querySelector('.spa-card__title')) {
      SpartaUILayersModal.formatTitle(options, modalLayerElement);
    } else if (modalLayerElement.querySelector(`.spa-card__body #${options.contentId}_title`)) {


      if (modalLayerElement.querySelector('.spa-card__title')) {
        modalLayerElement.querySelector('.spa-card__title').setAttribute('data-font', 'cnx-bold');
      }


      modalLayerElement.querySelector(`.spa-card__body #${options.contentId}_title`).remove();
    }


    if (modalLayerElement.querySelector('[data-modal-footer]')) {
      const modalFooterElement = utility.createStickyFooter(modalLayerElement, options);
      modalLayerElement.querySelector('.spa-card').appendChild(modalFooterElement);
    }


    return modalLayerElement;
  },








  setTitleFromADA(settings, options) {

    const content = settings.content
      ? settings.content[0]
      : null;


    if (!content) {
      return false;
    }


    const childrenElements = [...content.querySelectorAll('h1, h2, h3, h4, h5, h6')];


    const titleItems = [];
    childrenElements.forEach((item) => {
      const contentBody = content.querySelector('.content');
      if (contentBody && !contentBody.contains(item)) {
        titleItems.push(item);
      }
    });


    if (titleItems.length) {
      settings.titleTag = 'div';
    } else if (!settings.title) {


      settings.title = options.title || options.titleText;
    }

    return settings;
  },







  formatTitle(options, modalLayerElement) {

    const childrenElements = [...modalLayerElement.querySelectorAll('h1, h2, h3, h4, h5, h6')];
    const modalCard = modalLayerElement.querySelector('.spa-card');
    const modalBody = modalLayerElement.querySelector('.spa-card__body');
    const modalContent = modalBody.querySelector('.content');
    let modalTitle = modalLayerElement.querySelector('.spa-card__head-wrapper');


    if (!modalTitle) {

      const modalLayerTitleWrapperElement = document.createElement('div');
      modalLayerTitleWrapperElement.classList.add('spa-card__head');
      modalLayerTitleWrapperElement.innerHTML = '<div class="spa-card__head-wrapper"></div>';

      if (modalCard) {
        modalCard.insertBefore(modalLayerTitleWrapperElement, modalBody);
        modalTitle = modalLayerElement.querySelector('.spa-card__head-wrapper');
      }
    }


    const modalLayerTitleElement = document.createElement('div');
    modalLayerTitleElement.id = `${options.contentId}_title`;
    modalLayerTitleElement.classList.add('spa-card__title');


    const titleItems = [];
    childrenElements.forEach((item) => {
      if (!modalContent.contains(item)) {
        titleItems.push(item);
      }
    });


    titleItems.forEach((item) => {
      modalLayerTitleElement.appendChild(item);
    });


    if (modalTitle && modalLayerTitleElement.childNodes.length) {
      modalTitle.insertBefore(modalLayerTitleElement, modalTitle.childNodes[0]);


      const checkTitleLength = [...modalTitle.querySelectorAll('h1, h2, h3, h4, h5, h6')];
      if (checkTitleLength.length === 1) {
        const currentElement = checkTitleLength[0];
        const tagSwap = document.createElement('h1');
        tagSwap.innerHTML = currentElement.innerHTML;
        currentElement.parentNode.replaceChild(tagSwap, currentElement);
      }
    }
  },






  setBranding: (branding) => {
    let cardSkin;
    switch (branding) {
      case 'co-brand':
      case 'default':
      case 'enterprise':
        cardSkin = 'red';
        break;
      case 'edge':
        cardSkin = 'blue';
        break;
      case 'enterprise-two':
      case 'small-biz':
        cardSkin = 'gray';
        break;
      default:
        cardSkin = 'white';
    }

    return cardSkin;
  },







  modalCTA(options, settings) {

    const placementDomElement = '<p class="site-specific-placeholder-content"></p>';


    const cancelBtnText = settings.interstitialContent.btnText2[options.interstitialBranding]
      || settings.interstitialContent.btnText2.default;


    const btnConfirm = `
      <a
        role="button"
        href="${settings.continueLink}"
        ${(options.targetAction === 'new-tab') ? ' target="_blank"' : ''}
        id="${settings.anchorID}${settings.classDefaults.continueLinkPostfixID}"
        class="
          spa-ui-modal-btn--continue
          spa-btn spa-btn--small
          spa-btn--primary
          ${(options.targetAction === 'new-tab') ? ' close-interstitial' : ''}
        "
      >
        ${settings.interstitialContent.btnText1}
      </a>
    `;


    const btnCancel = `
      <button
        type="button"
        id="${settings.anchorID}${settings.classDefaults.backLinkPostfixID}"
        class="
          spa-ui-modal-btn--cancel
          spa-btn spa-btn--small
          spa-btn--secondary
          close-interstitial
        "
      >
        ${cancelBtnText}
      </button>
    `;


    settings.content += `${placementDomElement}${btnConfirm}${btnCancel}`;

    return settings.content;
  },








  updateModalCTA($layer, url) {

    const layerElm = $layer.length
      ? $layer[0]
      : $layer;


    if (!layerElm || (url && typeof url !== 'string')) {
      return;
    }


    const continueBtn = layerElm.querySelector('.spa-ui-modal-btn--continue');


    if (continueBtn) {
      continueBtn.setAttribute('href', url);
    }
  },









  setTitle($layer, titleText, updateAdaText, modalId) {

    const modalWrapper = $layer[0];
    const updateADA = updateAdaText;

    let options;
    if (modalId.includes('SpartaUILayer')) {
      options = instance[`${modalId}`];
    } else {
      options = instance[`${modalId}SpartaUILayer`];
    }

    if (!options) {
      return;
    }


    const modalTitle = modalWrapper.querySelector('.spa-card__title');
    const modalDismissible = modalWrapper.querySelector('.spa-card__dismissible');


    if (modalDismissible && updateADA && 'modalCloseText' in options) {
      modalDismissible.setAttribute('aria-label', `${options.modalCloseText}: ${titleText}`.trim());
    }


    if (modalTitle) {
      modalTitle.innerHTML = titleText;
    }
  },
};

export default SpartaUILayersModal;
